import { useState, useCallback } from 'react';

const STORAGE_KEY = 'crm_ai_visual_settings';

const DEFAULTS = {
    style: 'morphing-gradient',  // morphing-gradient | siri-noise | particle-cloud | waveform-ring | simple-pulse | avatar
    enabled: true,
    ttsEnabled: false,
    ttsVoice: '',
    size: 'md',  // sm (48px) | md (64px) | lg (80px)
    avatarProvider: 'simli',  // simli (future)
};

const SIZE_MAP = { sm: 48, md: 64, lg: 80 };

function load() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        return raw ? { ...DEFAULTS, ...JSON.parse(raw) } : { ...DEFAULTS };
    } catch {
        return { ...DEFAULTS };
    }
}

export default function useAIVisualSettings() {
    const [settings, setSettings] = useState(load);

    const updateSettings = useCallback((patch) => {
        setSettings(prev => {
            const next = { ...prev, ...patch };
            localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
            return next;
        });
    }, []);

    const resetSettings = useCallback(() => {
        localStorage.removeItem(STORAGE_KEY);
        setSettings({ ...DEFAULTS });
    }, []);

    return {
        settings,
        updateSettings,
        resetSettings,
        sizePx: SIZE_MAP[settings.size] || 64,
    };
}
